import { gql } from '@apollo/client'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Table, Alert } from 'reactstrap'
import { PROCESS_CURRENCY_RATE_FILE_QUERY } from '../../../graphql'
import { FileUploadForm } from '../FileUploadForm'
import '../Custom.css'
import '../ItProjects/timekeeper.css'
import { getData } from '../CustomUtils'
import FormHeading from '../FormHeading'

export const PROCESS_CURRENCY_RATE_FILE = gql(PROCESS_CURRENCY_RATE_FILE_QUERY)

export default function UploadCurrencyFile() {
  console.log('UploadCurrencyFile rendered')

  const navigate = useNavigate()
  const [currencyRateInfo, setCurrencyRateInfo] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  async function processFile(fileName) {
    console.log('UploadCurrencyFile.processFile')
    getData(null, PROCESS_CURRENCY_RATE_FILE, 'processCurrencyRateFile', setCurrencyRateInfo, setGraphQLErrors, 'fileName', fileName)
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  }
  if (currencyRateInfo) {
    console.log(currencyRateInfo)
    if (currencyRateInfo.length > 0) {
      let resultRows = []
      for (let i = 0; i < currencyRateInfo.length; i++) {
        let row = []
        row.push(<td key={1}><b>Line Number {currencyRateInfo[i].lineNumber}</b></td>)
        row.push(<td key={2}>{currencyRateInfo[i].errorMessage}</td>)
        row.push(<td key={3}>{currencyRateInfo[i].fileContents}</td>)
        resultRows.push(<tr key={i}>{row}</tr>)
      }
      return (
        <div className="custom-scroll timekeeper-table" >
          <form className="form">
            <div>
              <Table bordered>
                <FormHeading headingText='Currency Rate Error Info' colSpan='3' />
                <tbody>
                  {resultRows}
                </tbody>
              </Table>
            </div>
            <h5 style={{ textAlign: 'center' }}>Please correct these errors and re-submit.</h5>
            <div className="custom-button-container">
              <Button color="primary" onClick={() => setCurrencyRateInfo(null)}>Ok</Button>
            </div>
          </form>
        </div>
      )
    } else {
      return (
        <div className="custom-scroll timekeeper-table" >
          <h3><b>Successfully Uploaded Currency Rates</b></h3>
          <div className="custom-button-container">
            <Button color="primary" onClick={() => navigate('/home')}>Ok</Button>
          </div>
        </div>
      )
    }
  }
  return <FileUploadForm setFileName={processFile} />
}